// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ns-table-col{min-width:80px!important}.ns-table-col-double-wrap{display:flex}.ns-table-img{margin-right:5px}.ns-table-col-status{min-width:9px;flex-shrink:0;width:24px;height:24px;display:flex;align-items:center;justify-content:center}.ns-table-col-status>span{width:9px;height:9px;border-radius:9px;background:#58aac3;display:inline-block}.ns-table-col-status.error>span{background:#f56161}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
